import './OkulSiparisDetayPage.scss'

import type { TabsProps } from 'antd'
import { Collapse, Table, Tabs } from 'antd'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useOkulSiparisDetayQuery } from '../../../../gql/GeneratedGraphqlTypes'
import {getFormattedPrice} from "../../../../helpers/Formatting";
import Spinner from '../../../spinner/Spinner'
import { ReactComponent as HepsiJet } from '../okul-siparis-page/icons/hepsiJet.svg'
import { ReactComponent as YurtIci } from '../okul-siparis-page/icons/yurtKargo.svg'
import { ReactComponent as DeliveredIcon } from './icons/delivered.svg'
import { ReactComponent as NotDeliveredIcon } from './icons/not-delivered.svg'
import { ReactComponent as NoteIcon } from './icons/note.svg'

const { Panel } = Collapse

dayjs.extend(isBetween)

const OkulSiparisDetayPage: React.FC = () => {
  const { siparisId } = useParams()
  const navigate = useNavigate()
  // API isteğini gerçekleştir
  const { data, loading, error } = useOkulSiparisDetayQuery({
    variables: { siparis_id: parseInt(siparisId!) },
    skip: !siparisId || isNaN(Number(siparisId)), // Geçersiz ID varsa isteği yapma
  })

  if (loading) {
    return <Spinner showSpinner={loading} color="red" />
  }

  if (error) {
    console.error('API Hatası:', error)
    navigate('/')
    return null
  }
  // Sipariş bilgileri const
  const orderDetail = data?.okulSiparisDetay?.siparis_bilgileri?.GenelBilgiler
  const orderPaymentDetail = data?.okulSiparisDetay?.siparis_bilgileri?.OdemeBilgileri
  const orderDeliveryDetail = data?.okulSiparisDetay?.siparis_bilgileri?.TeslimatBilgileri
  // sipariş satırı const
  const orderLine = data?.okulSiparisDetay?.siparis_satirlari

  const orderBillingData = data?.okulSiparisDetay?.siparis_faturalari

  const orderBillingColumns = [
    {
      title: 'Fatura Kodu',
      dataIndex: 'fatura_kodu',
      key: 'fatura_kodu',
    },
    {
      title: 'Kargo Takip No',
      dataIndex: 'kargo_takip_no',
      key: 'kargo_takip_no',
      render: (text: string) => {
        const cleanedText = text.replace(/['",()]/g, '')
        return <span>{cleanedText}</span>
      },
    },
    {
      title: 'Kargo Url',
      dataIndex: 'kargo_url',
      key: 'kargo_url',
      render: (text: string) => {
        const cleanedText = text.replace(/['",()]/g, '')
        return (
          <a className="cargo-url-a" target="_blank" href={cleanedText} rel="noreferrer">
            Görüntüle
          </a>
        )
      },
    },
    {
      title: 'Kargo Mail',
      dataIndex: 'kargo_maili_gonderildi',
      key: 'kargo_maili_gonderildi',
      render: (text: boolean) =>
        text ? (
          <div className="icon">
            <DeliveredIcon /> Gönderildi
          </div>
        ) : (
          <div className="icon">
            <NotDeliveredIcon /> Gönderilmedi
          </div>
        ),
    },

    {
      title: 'Kargoya Verilme Tarihi',
      dataIndex: 'kargoya_verilme_tarihi',
      key: 'kargoya_verilme_tarihi',
      width: '15%',
      sorter: (a: any, b: any) => a.kargoya_verilme_tarihi - b.kargoya_verilme_tarihi,
    },
    {
      title: 'Kargo Teslim Tarihi',
      dataIndex: 'kargo_teslim_tarihi',
      key: 'kargo_teslim_tarihi',
      width: '15%',
      sorter: (a: any, b: any) => a.kargo_teslim_tarihi - b.kargo_teslim_tarihi,
    },
  ]

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Sipariş Bilgileri',
      children: (
        <div className="okul-yonetim-admin-detail-tab">
          <div className="tab-container">
            <h1>Sipariş Bilgileri</h1>
            <div className="tab-content">
              <div className="tab-content-row">
                <div className="tab-content-row-label">Sipariş ID</div>
                <div className="tab-content-row-value">{orderDetail?.order_id ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Trans ID</div>
                <div className="tab-content-row-value">{orderDetail?.trans_id ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Sepet</div>
                <div className="tab-content-row-value">{orderDetail?.sepet ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Kullanıcı</div>
                <div className="tab-content-row-value">{orderDetail?.user ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Durum</div>
                <div className="tab-content-row-value">{orderDetail?.durum_aciklama ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Tarih</div>
                <div className="tab-content-row-value">{orderDetail?.tarih ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">İade Talebi</div>
                <div className="tab-content-row-value">{orderDetail?.iade_talebi ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">İade Tarihi</div>
                <div className="tab-content-row-value">{orderDetail?.iptal_tarihi}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Bilgilendirme</div>
                <div className="tab-content-row-value">
                  {orderDetail?.bilgilendirme_maili_gonderildi
                    ? 'Bilgilendirme maili gönderildi.'
                    : 'Bilgilendirme maili gönderilmedi.'}
                </div>
              </div>
            </div>
          </div>
          <div className="tab-container">
            <h1>Ödeme Bilgileri</h1>
            <div className="tab-content">
              <div className="tab-content-row">
                <div className="tab-content-row-label">Havale Hesabı</div>
                <div className="tab-content-row-value">{orderPaymentDetail?.havale_yapilacak_hesap ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Kredi Kartı Vade</div>
                <div className="tab-content-row-value">{orderPaymentDetail?.kredi_karti_vade_secenegi ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Kargo Ücreti</div>
                <div className="tab-content-row-value">{getFormattedPrice(orderPaymentDetail?.kargo_ucreti ? orderPaymentDetail.kargo_ucreti : '0') ?? '-'} TL </div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Vade Ücreti</div>
                <div className="tab-content-row-value">{orderPaymentDetail?.vade_ucreti ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Toplam Tutar</div>
                <div className="tab-content-row-value">{getFormattedPrice(orderPaymentDetail?.toplam_tutar ? orderPaymentDetail.toplam_tutar.toString() : '0') ?? '-'} TL</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Ödeme Tipi</div>
                <div className="tab-content-row-value">{orderPaymentDetail?.odeme_tipi_aciklama ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Kapıda Ödeme</div>
                <div className="tab-content-row-value">{orderPaymentDetail?.kapida_odeme_hizmet_bedeli ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Kredi Kartı Pos</div>
                <div className="tab-content-row-value">{orderPaymentDetail?.kredi_karti_pos ?? '-'}</div>
              </div>
            </div>
          </div>
          <div className="tab-container">
            <h1>Teslimat Bilgileri</h1>
            <div className="tab-content">
              <div className="tab-content-row">
                <div className="tab-content-row-label">Kargo Firması</div>
                <div className="tab-content-row-value">
                  {orderDeliveryDetail?.kargo_firmasi === 'HepsiJet' ? (
                      <HepsiJet/>
                  ) : orderDeliveryDetail?.kargo_firmasi === 'Yurt İçi Kargo' ? (
                      <YurtIci/>
                  ) : (
                      orderDeliveryDetail?.kargo_firmasi
                  )}
                </div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Kargo Tipi</div>
                <div className="tab-content-row-value">{orderDeliveryDetail?.kargo_tipi_aciklama ?? '-'}</div>
              </div>
              <div className="tab-content-row">
                <div className="tab-content-row-label">Kargo Takip Numarası</div>
                <div className="tab-content-row-value">{orderPaymentDetail?.kargo_takip_no_listesi ?? '-'}</div>
              </div>
              <div className="tab-content-row delivery-address">
                <div className="tab-content-row-label ">Teslimat Adresi</div>
                <div className="tab-content-row-value">{orderDeliveryDetail?.teslimat_adresi ?? '-'}</div>
              </div>
              <div className="tab-content-row delivery-address">
                <div className="tab-content-row-label">Fatura Adresi</div>
                <div className="tab-content-row-value">{orderDeliveryDetail?.fatura_adresi ?? '-'}</div>
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      key: '2',
      label: (
          <>
            Sipariş Satırları <span className="line-count">{orderLine?.length} </span>{' '}
          </>
      ),
      children: (
          <div className="okul-yonetim-admin-collapse-tap">
          {orderLine?.map((line, index) => (
            <Collapse key={index} bordered={false}>
              <Panel
                header={
                  <div className="collapse-header-content">
                    <div className="header-title">
                      <span className="header-left">#{line?.id} </span>
                      <span className="header-right okul-order-product-name">{line?.urun ?? '-'} </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">Öğrenci Adı </span>
                      <span className="header-right">{line?.ogrenci_ismi ?? '-'} </span>
                    </div>{' '}
                    <div className="header-title">
                      <span className="header-left">Adet </span>
                      <span className="header-right">{line?.adet ?? '-'} </span>
                    </div>{' '}
                    <div className="header-title">
                      <span className="header-left">Fiyat</span>
                      <span className="header-right">{line?.birim_fiyat ?? '-'} TL </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">Durum</span>
                      <span className="header-right">{line?.durum_aciklama ?? '-'} </span>
                    </div>
                  </div>
                }
                key="1"
              >
                <div className="admin-collapse-content-div">
                  <div className="okul-sepeti-admin-student-info">
                    <div className="header-title">
                      <span className="header-left">Öğrenci </span>
                      <span className="header-right">{line?.ogrenci_ismi ?? '-'} </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">T.C. No </span>
                      <span className="header-right">{line?.kimlik_no ?? '-'} </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">Sınıf </span>
                      <span className="header-right"> - </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">Cinsiyeti </span>
                      <span className="header-right">{line?.ogrenci_cinsiyet ?? '-'} </span>
                    </div>
                  </div>
                  <div className="okul-sepeti-admin-product-info">
                    <div className="header-title">
                      <span className="header-left">Ürün </span>
                      <span className="header-right">{line?.urun ?? '-'} </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">Fatura </span>
                      <span className="header-right">- </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">Sıra </span>
                      <span className="header-right">{line?.sira ?? '-'} </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">Adet </span>
                      <span className="header-right">{line?.adet ?? '-'} </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">Kalan Adet </span>
                      <span className="header-right">{line?.kalan_adet ?? '-'} </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">Birim Fiyat </span>
                      <span className="header-right">{line?.birim_fiyat ?? '-'} TL</span>
                    </div>
                  </div>
                  <div className="okul-sepeti-admin-refund-info">
                    <div className="header-title">
                      <span className="header-left">İade talep adet </span>
                      <span className="header-right">- </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">İade talep tarih </span>
                      <span className="header-right">{orderDetail?.iptal_tarihi ?? '-'} </span>
                    </div>
                    <div className="header-title">
                      <span className="header-left">Durum </span>
                      <span className="header-right">{line?.durum_aciklama ?? '-'} </span>
                    </div>
                  </div>
                </div>
              </Panel>
            </Collapse>
          ))}
        </div>
      ),
    },
    {
      key: '3',
      label: 'Sipariş  Faturaları',
      children: (
        <div className="order-detail-table">
          <Table
            rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-light' : 'table-row-dark')}
            columns={orderBillingColumns}
            dataSource={orderBillingData as object[]}
            pagination={false}
          />
        </div>
      ),
    },
  ]
  return (
    <div className="okul-siparis-detay-page">
      <div className="okul-sepeti-admin-header">
        <h1>Okul Siparişleri</h1>
      </div>

      {/* Sipariş Detaylarını Göster */}
      <div className="siparis-detay">
        {data?.okulSiparisDetay ? <Tabs defaultActiveKey="1" items={items} /> : <p>Sipariş bilgisi bulunamadı.</p>}
      </div>
      <div className="okul-sepet-detail-order-note">
        <h1>
          <NoteIcon /> Sipariş Notu{' '}
        </h1>
        <span> {data?.okulSiparisDetay?.siparis_bilgileri?.GenelBilgiler?.siparis_notu}</span>
      </div>
    </div>
  )
}

export default OkulSiparisDetayPage
